import get from 'lodash/get';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import {
  selectIsMobile,
  selectIsSmallTablet,
  selectIsTablet,
} from 'redux/selectors/layout';
import { getDocumentFields } from 'utils/helper';
import styles from '../AssessmentCtaSection.module.scss';

export default ({
  section,
  type,
  withSlider: sectionWithSlider,
  withOverlay,
  data,
  handleOnCTAClick: handleOnCTAClickCommon,
  ...rest
}) => {
  const {
    title,
    description,
    formattedDescription,
    subtitle,
    view,
    contentModules,
    images: rawImages,
  } = getDocumentFields(
    data || section,
    [
      'title',
      'description',
      'formattedDescription',
      'contentModules',
      'subtitle',
      'view',
      'images',
    ],
    {
      isNormilized: (data && !Object.keys(data).includes('fields'))
      || (section && !Object.keys(section).includes('fields')),
    },
  );

  const {
    disableSliderOnMobile,
    enableSliderOnDesktop,
    enableSliderOnMobile,
  } = getDocumentFields(
    get(contentModules, '[0]', []),
    [
      'contentModules',
      'withoutBackground',
      'disableSliderOnMobile',
      'enableSliderOnDesktop',
      'enableSliderOnMobile',
      'svgWithWrapper',
    ],
  );

  const isMobileResolution = useSelector(selectIsMobile);
  const isTabletResolution = useSelector(selectIsTablet);
  const isSmallTabletResolution = useSelector(selectIsSmallTablet);

  const withSlider = sectionWithSlider
  || enableSliderOnDesktop
  || (!disableSliderOnMobile && (isTabletResolution || isSmallTabletResolution || isMobileResolution)) || (enableSliderOnMobile && isMobileResolution);

  const className = cn(
    styles.cardsSection,
    styles[type],
    styles[view],
    {
      [styles.withSlider]: withSlider,
    },
  );

  return {
    className,
    ...rest,
  };
};
